import { render, staticRenderFns } from "./headertab.vue?vue&type=template&id=547d2384&scoped=true"
import script from "./headertab.vue?vue&type=script&lang=js"
export * from "./headertab.vue?vue&type=script&lang=js"
import style0 from "./headertab.vue?vue&type=style&index=0&id=547d2384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d2384",
  null
  
)

export default component.exports